import * as React from 'react';
import Login from '../login/container';
import Expenses from '../expenses/container';
import Accounts from '../accounts/container';
import UpdateExpense from '../expenses/update-expense/container';
import UpdateAccount from '../accounts/update-account/container';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import Dashboard from '../dashboard/component';
import SetPassword from '../set-password/container';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logout } from '../actions/user';
import PrivateRoute from './private-route';
import LandingPage from '../pages/landing-page';
import Overview from '../overview/container';
import LearnMore from '../pages/learn-more';
import Settings from '../settings/container';
import SearchExpenses from '../expenses/search-expenses/container';
import NoMatch from './no-match';
import SideNavButton from './side-nav-button';
import Back from './back';
import navButtons from './nav-buttons';
import {
  AddAccountLink,
  OverviewLink,
  SearchLink,
  ContactUsLink,
  SettingsLink,
  LogoutLink,
  SignupLink,
  LoginLink
} from './links';

const Empty = () => null;

class MyApp extends React.Component<{ isLoggedIn; isFullyLoggedIn; logout; error; user }, any> {
  componentDidUpdate() {
    $('.dropdown-avatar').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false, // Does not change width of dropdown to that of the activator
      hover: false, // Activate on hover
      gutter: 0, // Spacing from edge
      belowOrigin: true, // Displays dropdown below the button
      alignment: 'left', // Displays dropdown with edge aligned to the left of button
      stopPropagation: false // Stops event propagation
    });
  }

  renderDesktopBar() {
    const { isLoggedIn, isFullyLoggedIn } = this.props;
    return [
      <Link to={isLoggedIn ? '/dashboard' : '/'} id="logo-container" className="brand-logo center">
        <span className="logo">Kimbix</span>
      </Link>,
      <ul className="right hide-on-med-and-down">
        {isFullyLoggedIn && <OverviewLink />}
        {isFullyLoggedIn && <SearchLink />}
        {isFullyLoggedIn && <ContactUsLink icon={true} />}
        {!isLoggedIn && <LoginLink />}
        {!isLoggedIn && <SignupLink />}
      </ul>
    ];
  }

  renderDropDown() {
    const { isLoggedIn, logout, user } = this.props;
    return [
      isLoggedIn && (
        <a className="right dropdown-avatar  hide-on-med-and-down" href="#" data-activates="logout">
          <img height="40" src={user.avatar} alt="avatar" className="circle middle" />
        </a>
      ),
      <ul id="logout" className="right dropdown-content hide-on-med-and-down">
        <AddAccountLink />
        <SettingsLink />
        <LogoutLink logout={logout} />
      </ul>
    ];
  }

  renderMobileBar() {
    const { isLoggedIn, isFullyLoggedIn, logout, user } = this.props;

    return (
      <div>
        <ul id="nav-mobile" className="side-nav indigo lighten-5">
          {isFullyLoggedIn && (
            <li>
              <Link to="/dashboard">Dashboard</Link>
            </li>
          )}
          {navButtons(isLoggedIn, isFullyLoggedIn, logout)}
        </ul>

        <Switch>
          <Route exact path="/dashboard" component={SideNavButton} />
          <Route path="/login" component={Empty} />
          <Route path="/signup" component={Empty} />
          <Route exact path="/" component={SideNavButton} />
          <Route path="/set-password" component={SideNavButton} />
          <Route path="/expenses" component={SideNavButton} />
          <Route path="/accounts" component={SideNavButton} />
          <Route component={Back} />
        </Switch>
      </div>
    );
  }

  renderRoutes() {
    return [
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route component={Empty} />
      </Switch>,
      <div className="section no-pad-bot" id="index-banner">
        <div className="container">
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Login} />
            <PrivateRoute path="/set-password" component={SetPassword} />
            <Route exact path="/" component={Empty} />
            <Route exact path="/learn-more" component={LearnMore} />
            <PrivateRoute path="/dashboard" component={Dashboard} />
            <PrivateRoute path="/settings" component={Settings} />
            <PrivateRoute path="/expenses" component={Expenses} />
            <PrivateRoute path="/overview" component={Overview} />
            <PrivateRoute path="/add-expense" component={UpdateExpense} />
            <PrivateRoute path="/add-account" component={UpdateAccount} />
            <PrivateRoute path="/update-expense" component={UpdateExpense} />
            <PrivateRoute path="/update-account" component={UpdateAccount} />
            <PrivateRoute path="/accounts" component={Accounts} />
            <PrivateRoute path="/search-expenses" component={SearchExpenses} />
            <Route component={NoMatch} />
          </Switch>
        </div>
      </div>
    ];
  }

  renderErrors() {
    const { error } = this.props;

    return (
      error && (
        <div className="row">
          <div className="card-panel red lighten-2">{error}</div>
        </div>
      )
    );
  }

  render() {
    const { isLoggedIn, isFullyLoggedIn, logout, error, user } = this.props;
    return (
      <Router>
        <div>
          <nav className=" light-blue darken-4 small">
            <div className="nav-wrapper container">
              {this.renderDropDown()}
              {this.renderDesktopBar()}
              {this.renderMobileBar()}
            </div>
          </nav>

          {this.renderErrors()}
          {this.renderRoutes()}
        </div>
      </Router>
    );
  }
}

export default MyApp;



// WEBPACK FOOTER //
// ./src/my-app/component.tsx